import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import LinkButton from "./LandingPage/LinkButton";
import ValidationFailureMessage from "./ValidationFailureMessage";
import MastercardImage from "../Images/ECMC.gif";
import VisaImage from "../Images/VISA.gif";
import MaestroImage from "../Images/MAESTRO.gif";
import PageHeader from "./PageHeader";
import Breadcrumb from "./Breadcrumb";

import CreateAddReviewAndDeclarationsAction from "../store/actionCreators/CreateAddReviewAndDeclarationsAction";
import CreateGetPricingsAction from "../store/actionCreators/CreateGetPricingsAction"
import CreateIssueLicenceApplicationAction from "../store/actionCreators/CreateIssueLicenceApplicationAction";
import CreateGetWebsiteConfigAction from "../store/actionCreators/CreateGetWebsiteConfigAction";
import CreateCancelLicenceApplicationAction from "../store/actionCreators/CreateCancelLicenceApplicationAction";
import CreateUndoCancelLicenceApplicationAction from "../store/actionCreators/CreateUndoCancelLicenceApplicationAction";
import CreateGetLicenceNotesAction from "../store/actionCreators/CreateGetLicenceNotesAction";
import CreateGetLicenceApplicationByIdAction from "../store/actionCreators/CreateGetLicenceApplicationByIdAction";
import CreateCheckLicenceAmendmentAction from "../store/actionCreators/CreateCheckLicenceAmendmentAction";
import CreateGetReviewDataAction from "../store/actionCreators/CreateGetReviewDataAction";

class AddReviewAndDeclarations extends Component {
    // Define LicenceStatus at class level so it's accessible in all methods
    LicenceStatus = {
            InProgress: 1,
            ReadyToReview: 2,
            AwaitingResponse: 3,
            LicenceIssued: 4,
            Dispatched: 5,
            Cancelled: 6
        };

    // Define ApplicationType at class level so it's accessible in all methods
    ApplicationType = {
            NewShipRadioLicence: 1,
            TransferLicence: 2,
            AmendLicence: 3
        };

    constructor(props) {
        super(props);
        this.state = {
            showMarkAsPaidModal: false,
            markAsPaidNote: "",
            markAsPaidSaving: false,
        };
    }

    componentDidMount() {
        this.props.setDeclarationsCheckBoxToDefault();
        this.props.getPricingsAction();
        this.props.getWebsiteConfig();
        
        // Load licence application data from URL parameter
        console.log(this.props.match);
        const licenceApplicationId = this.props.match.params.id;
        if (licenceApplicationId) {
            console.log("licenceApplicationId=" + licenceApplicationId);
            this.props.getLicenceApplicationById(licenceApplicationId);
            
            // Load review data for potential licence reviews
            this.props.getReviewData(licenceApplicationId);
        }
    }

    isLicenceStatus() {
        // Check if this is an issued or dispatched licence (potential review candidate)
        return this.props.licenceApplicationStatusTypeId === this.LicenceStatus.LicenceIssued || 
               this.props.licenceApplicationStatusTypeId === this.LicenceStatus.Dispatched;
    }

    isLicenceAmendment() {
        // Check if this is an issued or dispatched licence and if amendment
        const appTypeId = Number(this.props.applicationTypeId) || 0;

        return (this.props.licenceApplicationStatusTypeId === this.LicenceStatus.LicenceIssued ||
            this.props.licenceApplicationStatusTypeId === this.LicenceStatus.Dispatched) &&
            appTypeId === this.ApplicationType.AmendLicence;
    }

    isLicenceReview() {
        // Only show review section for licences that actually need review
        // Must be an issued/dispatched licence AND in the licencesRequiringReview list
        const isIssuedOrDispatched = this.props.licenceApplicationStatusTypeId === this.LicenceStatus.LicenceIssued || 
                                   this.props.licenceApplicationStatusTypeId === this.LicenceStatus.Dispatched;
        
        if (!isIssuedOrDispatched) {
            return false; // In-progress licences are never reviews
        }
        
        // Check if this licence is in the licencesRequiringReview list
        const licencesRequiringReview = this.props.licencesRequiringReview || [];
        return licencesRequiringReview.some(licence => 
            licence.licenceApplicationId === this.props.licenceApplicationId
        );
    }

    requiresPayment() {
        // New applications (InProgress status) require payment or amendments were made
        const appTypeId = Number(this.props.applicationTypeId) || 0;
        if (this.props.licenceApplicationStatusTypeId === this.LicenceStatus.InProgress ||
            appTypeId === this.ApplicationType.AmendLicence) {
            return true;
        }

        return false;
    }
    async handleMarkAsPaid() {
        const { licenceApplicationId } = this.props;
        this.setState({ markAsPaidSaving: true });
        try {
            const response = await fetch(
                `/api/Payment/MarkAsPaid?licenceApplicationId=${licenceApplicationId}&reason=${encodeURIComponent(this.state.markAsPaidNote)}`,
                { method: 'POST' }
            );
            if (!response.ok) {
                throw new Error(`MarkAsPaid failed: ${response.status}`);
            }
            this.setState({ showMarkAsPaidModal: false, markAsPaidNote: "", markAsPaidSaving: false });
            window.location.reload();
        } catch (err) {
            console.error('Mark as Paid error:', err);
            this.setState({ markAsPaidSaving: false });
        }
    }

    getNextReviewDate() {
        if (this.props.reviewData && this.props.reviewData.reviewDueDate) {
            const currentReviewDate = new Date(this.props.reviewData.reviewDueDate);
            //const issueDate = new Date(this.props.licenceIssuedDate);
            
            // Get the current review's milestone (which review we're completing)
            //const yearsSinceIssue = Math.floor((currentReviewDate - issueDate) / (1000 * 60 * 60 * 24 * 365));
            //const currentMilestone = Math.ceil(yearsSinceIssue / 5) * 5;
            
            // Find the next incomplete review milestone
            //if (this.props.pendingReviews && this.props.pendingReviews.length > 0) {
            //    // Sort pending reviews by due date
            //    const sortedReviews = [...this.props.pendingReviews]
            //        .sort((a, b) => new Date(a.reviewDueDate) - new Date(b.reviewDueDate));
                
            //    // Find the next pending review after the current one
            //    const nextPendingReview = sortedReviews.find(review => 
            //        new Date(review.reviewDueDate) > currentReviewDate);
                
            //    if (nextPendingReview) {
            //        return new Date(nextPendingReview.reviewDueDate).toLocaleDateString('en-GB');
            //    }
            //}
            
            // If no pending reviews found, calculate the next milestone
            //const nextMilestone = currentMilestone + 5;
            const nextReviewDate = new Date(currentReviewDate);
            nextReviewDate.setFullYear(currentReviewDate.getFullYear() + 5);
            
            return nextReviewDate.toLocaleDateString('en-GB');
        }
        
        // Fallback to first 5-year review if no review data available
        if (this.props.licenceIssuedDate) {
            const issueDate = new Date(this.props.licenceIssuedDate);
            const nextReviewDate = new Date(issueDate);
            nextReviewDate.setFullYear(issueDate.getFullYear() + 5);
            return nextReviewDate.toLocaleDateString('en-GB');
        }
        return '';
    }

    render() {
        const { t } = this.props;

        // For payment display purposes, determine the effective application type
        var effectiveApplicationTypeId = Number(this.props.applicationTypeId) || 0;

        // Get payment amount from configured payment details
        //var paymentDetail = this.props.paymentDetails.filter(p => p.applicationTypeId === this.props.applicationTypeId)[0];
        var paymentDetail = this.props.paymentDetails.find(p => p.applicationTypeId === effectiveApplicationTypeId);
        var paymentAmount = Number(paymentDetail?.price) || 0;

        // Pricing is fetched asynchronously in componentDidMount, so the first render can happen
        // before it has loaded - only warn once pricing data has actually arrived.
        if (this.props.paymentDetails.length > 0) {
            if (!paymentDetail) {
                console.warn(`No payment detail found for application type ${effectiveApplicationTypeId}`);
            } else if (paymentAmount === 0) {
                console.error(`No valid payment amount found for application type ${effectiveApplicationTypeId}. Please check payment configuration.`);
            }
        }

        var licenceTypeText;
        switch (effectiveApplicationTypeId) {
            case this.ApplicationType.NewShipRadioLicence:
                licenceTypeText = t("ReviewAndDeclarations.NewLicence");
                break;
            case this.ApplicationType.TransferLicence:
                licenceTypeText = t("ReviewAndDeclarations.TransferLicence");
                break;
            case this.ApplicationType.AmendLicence:
                licenceTypeText = t("ReviewAndDeclarations.LicenceAmendment");
                break;
        }

        const hasRequiredEquipment = (this.props.requiredEquipment !== null);
        const outstanding = hasRequiredEquipment && this.props.requiredEquipment?.outstandingRequiredEquipment || [];
        const outstandingGroups = hasRequiredEquipment && this.props.requiredEquipment?.outstandingRequiredEquipmentGrouped || [];

        const hasRequiredEpirbs = (this.props.requiredEpirbs !== null);
        const outstandingEpirbs = hasRequiredEpirbs && this.props.requiredEpirbs?.outstandingEpirbs || [];
        var hasOtherEpirb = false;
        if (hasRequiredEpirbs) {
            if (this.props.requiredEpirbs.addedEpirbsMatchingRequirement && this.props.requiredEpirbs.addedEpirbsMatchingRequirement.filter(e => e.isOtherModel).length > 0) {
                /* required epirb contains Other Model */
                hasOtherEpirb = true;
            } else if (this.props.requiredEpirbs.additionalEpirbs && this.props.requiredEpirbs.additionalEpirbs.filter(e => e.isOtherModel).length > 0) {
                /* additional epirb contains Other Model */
                hasOtherEpirb = true;
            }
        }

        const addedEquipmentMatchingRequirement = this.props.requiredEquipment?.addedEquipmentMatchingRequirement || [];
        const additionalAddedEquipment = this.props.requiredEquipment?.additionalAddedEquipment || [];
        const noEquipmentAdded = (hasRequiredEquipment)
            ? addedEquipmentMatchingRequirement.length === 0 && additionalAddedEquipment.length === 0
            : false;

        var radioOperatorClassName = "bg-light p-2 rounded-lg m-3 bg-customGood";
        var vesselDetailsClassName = "bg-light p-2 rounded-lg m-3 bg-customGood";
        var emergencyDetailsClassName = "bg-light p-2 rounded-lg m-3 bg-customGood";
        var vesselEquipmentDetailsClassName = "bg-light p-2 rounded-lg m-3 bg-customGood";
        var epirbDetailsClassName = "bg-light p-2 rounded-lg m-3 bg-customGood";

        var isShipOwerWithNonIssuedLicence = this.props.role === "Ship Owner" && (this.props.licenceApplicationStatusTypeId == this.LicenceStatus.InProgress
            || this.props.licenceApplicationStatusTypeId == this.LicenceStatus.ReadyToReview);

        const hasOutstandingItems = outstanding.length > 0 || outstandingGroups.length > 0 || outstandingEpirbs.length > 0;
        const allItemsGreen = !hasOutstandingItems && hasRequiredEquipment && this.props.emergencyContactsCount > 1;

        const notesButtonLabel = this.props.licenceNotes && this.props.licenceNotes.length > 0
            ? t("Common.ButtonText.Notes") + " *"
            : t("Common.ButtonText.Notes");

        const equipmentClassName = noEquipmentAdded
            ? 'bg-customError bg-light p-2 rounded-lg m-3'
            : hasRequiredEquipment && (outstanding.length > 0 || outstandingGroups.length > 0)
                ? 'bg-customWarning bg-light p-2 rounded-lg m-3'
                : 'bg-customGood bg-light p-2 rounded-lg m-3';

        const emergencyContactsClassName = this.props.emergencyContactsCount < 2
            ? 'bg-customError bg-light p-2 rounded-lg m-3'
            : 'bg-customGood bg-light p-2 rounded-lg m-3';

        return (
            <React.Fragment>

                <Modal show={this.props.showIssueModal} onHide={this.props.handleCloseIssueModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("ReviewAndDeclarations.IssueLicence")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {t("ReviewAndDeclarations.IssueLicenceQuestion", { vesselName: this.props.vesselName })}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button id="issueNoButton" variant="secondary" onClick={this.props.handleCloseIssueModal}>
                            &times; {t("Common.ButtonText.No")}
                        </Button>
                        <LinkButton id="issueYesButton"
                                    className="btn btn-primary"
                                    to={"/dashboard/"}
                                    onClick={() => { this.props.issueLicence(this.props.licenceApplicationId) }}>
                            &#10003; {t("Common.ButtonText.Yes")}
                        </LinkButton>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.props.showCancelModal} onHide={this.props.handleCloseCancelModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t("LicenceDetailsPage.CancelLicenceTile")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {t("LicenceDetailsPage.CancelLicenceQuestion")}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button id="cancelNoButton"
                            variant="success" onClick={this.props.handleCloseCancelModal}>
                            {t("Common.ButtonText.No")}
                        </Button>
                        <Button id="cancelYesButton"
                            variant="danger"
                            onClick={() => {
                                this.props.cancelLicence(this.props.licenceApplicationId, this.props.vesselId, this.props.applicationTypeId)
                            }}
                        >
                            {t("Common.ButtonText.Yes")}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.props.showUndoCancelModal} onHide={this.props.handleCloseUndoCancelModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Undo Cancel Licence</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to undo the licence cancellation?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button id="undoCancelNoButton"
                            variant="secondary"
                            onClick={
                                this.props.handleCloseUndoCancelModal}>
                            {t("Common.ButtonText.No")}
                        </Button>
                        <Button id="undoCancelYesButton"
                            variant="primary"
                            onClick={() => {
                                this.props.undoCancelLicence(this.props.licenceApplicationId)
                            }}>
                            {t("Common.ButtonText.Yes")}
                        </Button>
                    </Modal.Footer>
                </Modal>

            
                <Modal
                    show={this.state.showMarkAsPaidModal}
                    onHide={() => this.setState({ showMarkAsPaidModal: false, markAsPaidNote: "" })}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Mark as Paid</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form-group">
                            <label htmlFor="markAsPaidNoteInput"><strong>Reason <span className="text-danger">*</span></strong></label>
                            <textarea
                                id="markAsPaidNoteInput"
                                className="form-control mt-2"
                                rows={4}
                                placeholder="Enter reason for marking as paid (e.g. PO number, authorised by)..."
                                value={this.state.markAsPaidNote}
                                onChange={e => this.setState({ markAsPaidNote: e.target.value })}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            id="markAsPaidCancelButton"
                            variant="secondary"
                            onClick={() => this.setState({ showMarkAsPaidModal: false, markAsPaidNote: "" })}
                        >
                            &times; Cancel
                        </Button>
                        <Button
                            id="markAsPaidConfirmButton"
                            variant="success"
                            disabled={!this.state.markAsPaidNote.trim() || this.state.markAsPaidSaving}
                            onClick={() => this.handleMarkAsPaid()}
                        >
                            {this.state.markAsPaidSaving ? "Saving..." : "✓ Confirm Mark as Paid"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                

                <Breadcrumb
                    role={this.props.role}
                    homeLink={t("Common.ButtonText.Home")}
                    licenceList={t("AdminLandingPage.LicenceList")}
                    dashboard={t("Common.Dashboard")}
                    parentLink=""
                    parentPageName=""
                    pageName={t("ReviewAndDeclarations.TitleLabel")} />

                <PageHeader
                    pageTitle={t("ReviewAndDeclarations.TitleLabel")}
                    vesselLabel={t("OwnerLandingPage.VesselName")}
                    vesselName={this.props.vesselName}
                    isShipOwerWithNonIssuedLicence={isShipOwerWithNonIssuedLicence}
                    mmsiLabel={t("OwnerLandingPage.MMSINumber")}
                    mmsiNumber={this.props.mmsiNumber}
                    callSignLabel={t("OwnerLandingPage.CallSign")}
                    callSignNumber={this.props.callSignNumber}
                    pageDescription={t("ReviewAndDeclarations.StepLabel")}
                    requiredField="" />


               
                <div className="row">
                    <div className="rowCustom">
                        <div className="bg-customGoodFull">
                            <h6>{t("ReviewAndDeclarations.Good")}</h6>
                        </div>
                        <div className="bg-customWarningFull">
                            <h6>{t("ReviewAndDeclarations.Warning")}</h6>
                        </div>
                        <div className="bg-customErrorFull">
                            <h6>{t("ReviewAndDeclarations.ActionRequired")}</h6>
                        </div>
                    </div>

                    <div>
                        <div className={ radioOperatorClassName }>
                            <div className="row">
                                <div className="col-md-9">
                                    <label id="RadioOperatorCertificateDetailsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.Step1")}{t("ReviewAndDeclarations.RadioOperatorCertificateDetailsLabel")}</h5>
                                    </label>
                                </div>
                                <div className="col-md-3">
                                    {
                                        this.props.licenceApplicationId > 0 &&
                                        <Link
                                            id="updateOperatorCertificateButton"
                                            className="btn btn-primary float-end"
                                            to={this.props.parentRoute + "/licence/" + this.props.licenceApplicationId}>
                                            {t("Common.ButtonText.Review")}
                                        </Link>
                                    }
                                </div>
                            </div>
                        </div>

                        <hr/>

                        <div className={ vesselDetailsClassName }>
                            <div className="row">
                                <div className="col-md-9">
                                    <label id="VesselDetailsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.Step2")}{t("ReviewAndDeclarations.VesselDetailsLabel")}</h5>
                                    </label>
                                </div>
                                <div className="col-md-3">
                                    {
                                        this.props.licenceApplicationId > 0 &&
                                        <Link
                                            id="updateVesselDetailsButton"
                                            className="btn btn-primary float-end"
                                            to={this.props.parentRoute + "/add-vessel/" + this.props.licenceApplicationId}>
                                            {t("Common.ButtonText.Review")}
                                        </Link>
                                    }
                                </div>
                            </div>
                        </div>

                        <hr/>
                        {/* Step3 - Emergency Details */}
                        <div className={emergencyDetailsClassName}>
                            <div className="row">
                                <div className="col-md-9">
                                    <label id="EmergencyDetailsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.Step3")}{t("ReviewAndDeclarations.EmergencyDetailsLabel")} </h5>
                                    </label>
                                </div>
                                <div className="col-md-3">
                                    {
                                        this.props.licenceApplicationId > 0 &&
                                        <Link
                                            id="updateEmergencyContactButton"
                                            className="btn btn-primary float-end"
                                            to={this.props.parentRoute + "/emergency-contacts-list/" + this.props.licenceApplicationId}>
                                            {t("Common.ButtonText.Review")}
                                        </Link>
                                    }
                                </div>
                                {
                                    (this.props.emergencyContactsCount < 2) &&
                                    <div className="col-md-12">
                                        <ValidationFailureMessage>
                                            {t("ReviewAndDeclarations.EmergencyContactsRequired")}
                                        </ValidationFailureMessage>
                                    </div>
                                }
                            </div>
                        </div>
                        <hr/>

                        {/* Step4 - Equipment Details */}
                        <div className={equipmentClassName}>
                            <div className="row">
                                <div className="col-md-9">
                                    <label id="vesselEquipmentDetailsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.Step4")}{t("ReviewAndDeclarations.VesselEquipmentDetailsLabel")}</h5>
                                    </label>
                                    <span className="visually-hidden">
                                        Status is
                                        {
                                            noEquipmentAdded
                                                ? "Error"
                                                : hasRequiredEquipment && (outstanding.length > 0 || outstandingGroups.length > 0)
                                                    ? "Warning"
                                                    : "Good"
                                        }
                                    </span>
                                </div>
                                <div className="col-md-3">
                                    {
                                        this.props.licenceApplicationId > 0 &&
                                        <Link
                                            id="updateVesselEquipmentButton"
                                            className="btn btn-primary float-end"
                                            to={this.props.parentRoute + "/vessel-equipment-details/" + this.props.licenceApplicationId}>
                                            {t("Common.ButtonText.Review")}
                                        </Link>
                                    }
                                </div>
                                {
                                    hasOtherEpirb && (this.props.role === "Radio Surveyor" || this.props.role === "Department Admin Staff") &&
                                    <div className="col-md-12">
                                        <ValidationFailureMessage>
                                            {t("ReviewAndDeclarations.OtherEquipmentAdded")}
                                        </ValidationFailureMessage>
                                    </div>
                                }
                                {
                                    (noEquipmentAdded || (hasRequiredEquipment && (outstanding.length > 0 || outstandingGroups.length > 0))) &&
                                    <div className="col-md-12">
                                        <ValidationFailureMessage>
                                            {t("ReviewAndDeclarations.MinEquipmentRequired")}
                                        </ValidationFailureMessage>
                                    </div>
                                }
                            </div>
                        </div>
                        <hr/>
                        {/* Epirb Details */}
                        <div
                            className={hasRequiredEpirbs && outstandingEpirbs.length > 0
                               ? 'bg-customWarning bg-light p-2 rounded-lg m-3'
                               : 'bg-customGood bg-light p-2 rounded-lg m-3'
                            }>
                            <div className="row">
                                <div className="col-md-9">
                                    <label id="epirbDetailsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.EpirbDetailsLabel")} </h5>
                                    </label>
                                    <span className="visually-hidden">
                                        Status is
                                        {
                                            hasRequiredEpirbs && outstandingEpirbs.length > 0
                                                ? "Warning"
                                                : "Good"
                                        }
                                    </span>
                                </div>
                                {
                                    this.props.licenceApplicationStatusTypeId !== this.LicenceStatus.InProgress &&
                                    <div className="col-md-3">
                                        {
                                            this.props.licenceApplicationId > 0 &&
                                            <Link
                                                id="updateEpirbDetailsButton"
                                                className="btn btn-primary float-end"
                                                to={this.props.parentRoute + "/epirb-list/" + this.props.licenceApplicationId}
                                            >
                                                {t("Common.ButtonText.Review")}
                                            </Link>
                                        }
                                    </div>
                                }
                                {
                                    (this.props.role === "Radio Surveyor" || this.props.role === "Department Admin Staff") && hasOtherEpirb &&
                                    <div className="col-md-12">
                                        <ValidationFailureMessage>
                                            {t("ReviewAndDeclarations.OtherEpirbAdded")}
                                        </ValidationFailureMessage>
                                    </div>
                                }
                                <div className="col-md-12">
                                    <span tabIndex="0">
                                        <i>{t("ReviewAndDeclarations.EpirbDetailsNote")} </i>
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Review Notes Section - positioned after EPIRB Details */}
                        {(this.isLicenceReview()) && (
                            <div>
                                <hr/>
                                <div className="bg-light p-4 rounded-lg m-3 border">
                                    <h5>{t("ReviewAndDeclarations.ReviewNotes")}</h5>
                                    <div className="alert alert-info">
                                        <p>
                                            {t("ReviewAndDeclarations.ReviewNotesText")}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                        {
                            this.props.role === "Radio Surveyor" &&
                            this.props.licenceApplicationStatusTypeId !== this.LicenceStatus.Cancelled &&
                            <Link
                                id="cancelButton"
                                className="btn btn-warning me-3"
                                to="#"
                                onClick={() => { this.props.handleShowCancelModal() }}>
                                {t("LicenceDetailsPage.CancelLicenceTile")}
                            </Link>
                               
                        }

                        {
                            this.props.role === "Radio Surveyor" &&
                            this.props.licenceApplicationStatusTypeId === this.LicenceStatus.ReadyToReview &&
                            <Link
                                id="issueButton"
                                className="btn btn-success"
                                to="#"
                                onClick={() => { this.props.handleShowIssueModal() }}>
                                {t("ReviewAndDeclarations.IssueLicence")}
                            </Link>
                        }

                        {
                            (this.props.licenceApplicationStatusTypeId === this.LicenceStatus.LicenceIssued || 
                            this.props.licenceApplicationStatusTypeId === this.LicenceStatus.Dispatched) &&
                            (this.props.role === "Radio Surveyor" || this.props.role === "Department Admin Staff") &&
                            
                                <Link
                                    id="printButton"
                                    target="_new"
                                    className="my-3 btn btn-success"
                                    to={"/api/LicenceApplication/PrintShipsRadioLicence/?id=" + this.props.licenceApplicationId}
                                >
                                    {t("LicenceDetailsPage.ViewAndPrintLicenceTile")}
                                </Link>         
                        }

                        {
                            this.props.licenceApplicationStatusTypeId === this.LicenceStatus.Cancelled &&
                            this.props.role === "Radio Surveyor" &&
                            <Button id="btnUndoCancelLicence"
                                variant="primary" onClick={this.props.handleShowUndoCancelModal}>
                                Undo Licence Cancellation
                            </Button>
                        }

                        {
                            (this.props.role === "Radio Surveyor" || this.props.role === "Department Admin Staff") &&
                            <Link
                                id="btnNotes"
                                className="btn btn-secondary ms-3"
                                to={this.props.parentRoute + "/notes/" + this.props.licenceApplicationId}
                            >
                                {notesButtonLabel}
                            </Link>
                        }

                        {
                            (this.props.role === "Radio Surveyor" || this.props.role === "Department Admin Staff") &&
                            this.requiresPayment() &&
                            !noEquipmentAdded &&
                            outstanding.length === 0 &&
                            outstandingGroups.length === 0 &&
                            this.props.emergencyContactsCount > 1 &&
                           
                            <Button
                                id="btnMarkAsPaid"
                                variant="success"
                                className="ms-3"
                                onClick={() => this.setState({ showMarkAsPaidModal: true })}
                            >
                                Mark as Paid
                            </Button>
                            
                        }

                        {/* Single Payment Form - Only show if payment is required */}
                        {
                            (() => {
                                const paymentFormVisible = this.props.declarationsCheckbox &&
                                    this.requiresPayment();
                                
                                return paymentFormVisible;
                            })() &&
                            <div>
                                <hr/>
                                <div className="bg-light p-2 rounded-lg m-3 bg-customError"> 
                                    <label id="PaymentSummaryLabel" tabIndex="0"><h5>{t("ReviewAndDeclarations.PaymentSummaryLabel")}</h5></label>
                                    <p id="licenceLabel" tabIndex="0">{licenceTypeText}</p>
                                    <label id="TotalAmountLabel" tabIndex="0">{t("ReviewAndDeclarations.TotalAmountLabel")}</label> <br />
                                    <p><span>&#8364;</span>{paymentAmount}</p>
                                </div>

                                <form action={this.props.paymentEndpoint} method="POST">
                                    <input type="hidden" name="instId" value={this.props.paymentKey} />
                                    <input type="hidden" name="cartId" value={this.props.licencePaymentId} />
                                    <input type="hidden" name="amount" value={paymentAmount} />
                                    <input type="hidden" name="currency" value="EUR" />
                                    <input type="hidden" name="desc" value={licenceTypeText + " for " + this.props.vesselName} />
                                    {
                                        this.props.environment !== "Production" &&
                                        <input type="hidden" name="testMode" value="100" />
                                    }
                                    <input type="hidden" name="hideCurrency" value="" />
                                    <input type="hidden" name="lang" value="IE" />
                                    <input type="hidden" name="noLanguageMenu" value="" />
                                    <input type="hidden" name="MC_callback" value={ this.props.websiteUrl + "api/Payment/PaymentProcessed" } />
                                    <input type="hidden" name="MC_returnurl" value={ this.props.websiteUrl + "apply/payment-success/" + this.props.licenceApplicationId } />
                                    <input type="hidden" name="MC_cancelurl" value={ this.props.websiteUrl + "apply/review-declarations/" + this.props.licenceApplicationId } />

                                    <div className="row">
                                        <div className="col-md-8">
                                            <input type="submit" id="addPaymentDetailsButton" className="btn btn-primary mb-3" value={t("ReviewAndDeclarations.SubmitAndPay")} />
                                        </div>
                                        <div className="col-md-4">
                                            <img alt="MasterCard" src={MastercardImage} className="mx-1" />
                                            <img alt="Visa" src={VisaImage} className="mx-1" />
                                            <img alt="Maestro" src={MaestroImage} className="mx-1" />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        }

                        {/* Licence Review Completion (No Payment Required) */}
                        {
                            (() => {
                                const continueButtonVisible = (this.isLicenceReview()
                                    && this.props.declarationsCheckbox
                                    && !this.requiresPayment());
                                
                                return continueButtonVisible;
                            })() &&
                            <div>
                                <hr/>
                                <div className="alert alert-info">
                                    <p>
                                        {t("ReviewAndDeclarations.ContinueReviewText", { nextReviewDate: this.getNextReviewDate() })}
                                    </p>
                                </div>
                                <div className="row">
                                    <button 
                                        id="completeReviewButton"
                                        className="btn btn-primary mb-3"
                                        onClick={async (e) => {
                                            const button = e.target;
                                            const originalText = button.textContent;
                                            button.disabled = true;
                                            button.textContent = t("Common.ButtonText.Processing");
                                            
                                            try {
                                                await this.props.completeReview(this.props.licenceApplicationId);
                                                window.location.href = "/dashboard";
                                            } catch (error) {
                                                console.error("Error completing review:", error);
                                                alert(t("ReviewAndDeclarations.ReviewCompletionError"));
                                                button.disabled = false;
                                                button.textContent = originalText;
                                            }
                                        }}
                                    >
                                        {t("Common.ButtonText.Continue")}
                                    </button>
                                </div>
                            </div>
                        }




                        {/* Unified Declarations Section - handles both regular applications and reviews */}
                        {
                            (
                                // Regular applications - require all items to be green
                                (this.props.licenceApplicationStatusTypeId === this.LicenceStatus.InProgress && 
                                 !noEquipmentAdded && this.props.emergencyContactsCount > 1) ||
                                // Reviews - always show (licence is already valid, just reviewing)
                                (this.isLicenceReview()) ||
                                // Amendment reviews - show for issued/dispatched licences with amendments
                                (this.isLicenceAmendment())
                            ) &&
                            !this.props.declarationsCheckbox &&
                            <div>
                                <hr />
                               <div className={`bg-customError bg-light p-3 rounded-lg m-3`}>
                                    <label id="DeclarationsLabel" tabIndex="0">
                                        <h5>{t("ReviewAndDeclarations.DeclarationsLabel")}</h5>
                                    </label>
                                    
                                    <div>
                                        <p id="DeclarationLine1" tabIndex="0">
                                            {t("ReviewAndDeclarations.DeclarationLine1")}<br /><br />
                                            {t("ReviewAndDeclarations.DeclarationLine2")}<br /><br />
                                            {t("ReviewAndDeclarations.DeclarationLine3")}<br /><br />
                                            {t("ReviewAndDeclarations.DeclarationLine4")}<br /><br />
                                            {t("ReviewAndDeclarations.DeclarationLine5")}
                                        </p>
                                    </div>

                                   <div className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id="declarationsCheckboxCheckbox"
                                            onChange={evt => this.props.declarationsCheckboxCheckboxValueChanged(evt,
                                                this.props.licenceApplicationId, paymentAmount)}
                                            value={this.props.declarationsCheckbox}
                                        />
                                        <label id="declarationsCheckboxLabel" className="form-check-label" tabIndex="0">
                                            I agree to all
                                        </label>
                                   </div>
                                </div>
                            </div>
                        }
                        <hr/>
                        <br/>
                    </div>
                    <div>
                        {
                            this.props.declarationsCheckbox && !(hasRequiredEquipment && outstanding.length === 0 && outstandingGroups.length === 0) &&
                                <div className="h5" tabIndex="0"> {t("ReviewAndDeclarations.WarningWeMayNeedMoreInformation")}</div>
                        }
                    </div>

                </div>

            </React.Fragment>
);
}
}

const mapStateToProps = (state, ownProps) => {
    return {
        id: state.reviewAndDeclaration.id || 0,
        licenceApplicationId: state.currentApplication.id || 0,
        declarationsCheckbox: state.reviewAndDeclaration.declarationsCheckbox || false,
        paymentDetails: state.availablePricings,
        requiredEquipment: state.requiredEquipment || null,
        requiredEpirbs: state.requiredEpirbs || null,
        licenceApplicationStatusTypeId: state.currentApplication.licenceApplicationStatusTypeId || 0,
        applicationTypeId: state.currentApplication.applicationTypeId || 1,

        emergencyContacts: state.emergencyContactList,
        emergencyContactsCount: state.emergencyContactList.length || 0,

        //radio operator details
        nameOnCertificate: state.currentApplication.nameOnCertificate || "",
        certificateNumber: state.currentApplication.certificateNumber || "",
        dateOfBirth: state.currentApplication.dateOfBirth || "",

        //vessel details
        vesselTypeId: state.currentVessel.vesselTypeId || "",
        vesselSubTypeId: state.currentVessel.vesselSubTypeId || "",
        hasVesselSubTypes: state.currentVessel.hasVesselSubTypes ||
            (Number(state.currentVessel.vesselTypeId) === 1 || Number(state.currentVessel.vesselTypeId) === 3 ||
                Number(state.currentVessel.vesselTypeId) === 4) ? true : false,    
        seaAreaOfOperationId: state.currentVessel.seaAreaOfOperationId || "",
        hullColors: state.availableHullColor,
        maxVesselCapacity: state.currentVessel.maxCapacityOfPersonsOnBoard || "",
        vesselLength: state.currentVessel.vesselLength || "",
        grossTonnage: state.currentVessel.grossTonnage || "",
        vesselDescription: state.currentVessel.description || "",
        homeport: state.currentVessel.homePort || "",

        role: state.currentUserInfo.role || "",
        vesselName: state.currentVessel.name || "",
        callSignNumber: state.currentVessel.callSignNumber || "",
        mmsiNumber: state.currentVessel.mmsiNumber || "",
        vesselId: state.currentVessel.id || 0,
        showIssueModal: state.currentApplication.showIssueModal || false,
        licencePaymentId: state.licencePayment.id || 0,
        environment: state.websiteConfig.environment || "",
        paymentEndpoint: state.websiteConfig.paymentEndpoint || "",
        paymentKey: state.websiteConfig.paymentKey || "",
        websiteUrl: state.websiteConfig.websiteUrl || "",

        showCancelModal: state.currentUserInfo.showCancelModal || false,
        showUndoCancelModal: state.currentUserInfo.showUndoCancelModal || false,

        licenceNotes: state.licenceNotes || [],
        amendmentsRequirePayment: state.currentApplication.amendmentsRequirePayment || false,
        licenceIssuedDate: state.currentApplication.approved || null,
        parentRoute: "/apply",
        licencesRequiringReview: state.currentUserInfo.licencesRequiringReview || [],
        reviewData: state.review.reviewData || null,
        reviewDataLoading: state.review.reviewDataLoading || false,
        reviewDataError: state.review.reviewDataError || null,
        accountingAuthorityIdentificationCodeId: state.currentVessel.accountingAuthorityIdentificationCodeId || null
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        getPricingsAction: () => {
            dispatch(CreateGetPricingsAction());
        },
        getWebsiteConfig: () => {
            dispatch(CreateGetWebsiteConfigAction());
        },
        getLicenceNotes: (licenceApplicationId) => {
            dispatch(CreateGetLicenceNotesAction(licenceApplicationId));
        },
        getLicenceApplicationById: (licenceApplicationId) => {
            dispatch(CreateGetLicenceApplicationByIdAction(licenceApplicationId));
        },
        checkLicenceAmendment: (vesselId, licenceApplicationId, vesselName, accountingAuthorityIdentificationCodeId) => {
            dispatch(CreateCheckLicenceAmendmentAction(vesselId, licenceApplicationId, vesselName, accountingAuthorityIdentificationCodeId));
        },
        setDeclarationsCheckBoxToDefault: () => {
            dispatch({
                type: "DECLARATIONS_CHECKBOX_UPDATED",
                data: false
            });
        },
        declarationsCheckboxCheckboxValueChanged: (evt, licenceApplicationId, paymentAmount) => {
            var updateDeclarationsCheckbox = evt.target.checked;

            if (updateDeclarationsCheckbox) {
                dispatch(CreateAddReviewAndDeclarationsAction(licenceApplicationId, paymentAmount));
            }

            dispatch({
                type: "DECLARATIONS_CHECKBOX_UPDATED",
                data: updateDeclarationsCheckbox
            });
        },
        handleShowIssueModal: () => {
            dispatch({
                type: "ISSUE_LICENCE_SHOW_MODAL",
                data: true
            });
        },
        handleCloseIssueModal: () => {
            dispatch({
                type: "ISSUE_LICENCE_SHOW_MODAL",
                data: false
            });
        },
        issueLicence: (licenceApplicationId) => {
            dispatch(CreateIssueLicenceApplicationAction(licenceApplicationId));
            dispatch({
                type: "ISSUE_LICENCE_SHOW_MODAL",
                data: false
            });
        },
        handleShowCancelModal: () => {
            dispatch({
                type: "CANCEL_LICENCE_UPDATED_SHOW_CANCEL_MODAL",
                data: true
            });
        },
        handleCloseCancelModal: () => {
            dispatch({
                type: "CANCEL_LICENCE_UPDATED_SHOW_CANCEL_MODAL",
                data: false
            });
        },
        cancelLicence: (licenceApplicationId, vesselId, applicationTypeId) => {
            dispatch(CreateCancelLicenceApplicationAction(licenceApplicationId, vesselId, applicationTypeId, "admin"));
            dispatch({
                type: "CANCEL_LICENCE_UPDATED_SHOW_CANCEL_MODAL",
                data: false
            });
        },
        handleShowUndoCancelModal: () => {
            dispatch({
                type: "UNDO_CANCEL_LICENCE_SHOW_MODAL",
                data: true
            });
        },
        handleCloseUndoCancelModal: () => {
            dispatch({
                type: "UNDO_CANCEL_LICENCE_SHOW_MODAL",
                data: false
            });
        },
        undoCancelLicence: (licenceApplicationId) => {
            dispatch(CreateUndoCancelLicenceApplicationAction(licenceApplicationId));
            dispatch({
                type: "UNDO_CANCEL_LICENCE_SHOW_MODAL",
                data: false
            });
        },
        getReviewData: (licenceApplicationId) => {
            dispatch(CreateGetReviewDataAction(licenceApplicationId));
        },
        completeReview: (licenceApplicationId) => {
            return dispatch(CreateAddReviewAndDeclarationsAction(licenceApplicationId, 0, true));
        }
    }
}

const languageAwareComponent = withTranslation()(AddReviewAndDeclarations);
const routerAwareComponent = withRouter(languageAwareComponent);
export default connect(mapStateToProps, mapDispatchToProps)(routerAwareComponent);

